import LawsUzb from "./LawsUzb";

export default LawsUzb